import './CarNumberField.scss';
import {
  FormLabel,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from '@mui/material';
import TextField from '@mui/material/TextField';
import { carNumberToRaw, formatCarNumberInput } from '@utils/helpers';
import { t } from 'i18next';
import { ChangeEvent, useMemo } from 'react';

const CarNumberField = ({
  value,
  onChange,
  error,
  label,
  id,
  required,
  isShowText,
  width,
  icon,
  disabled,
  isPreRegistration = false,
}: CarNumberFieldProps) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const raw = carNumberToRaw(e.target.value);
    if (raw.length >= 5) return;

    onChange(raw);
  };

  const displayValue = useMemo(() => {
    return formatCarNumberInput(value ?? '');
  }, [value]);

  const errorText = useMemo(() => {
    if (error?.type === 'required' && !error.message) {
      return t('common.require_input_text');
    }

    return error?.message ? t(error?.message) : null;
  }, [error]);

  return (
    <Grid container className='CarNumberField' direction={'column'} spacing={2}>
      {label && (
        <Grid
          item
          xs={4}
          alignItems='center'
          justifyContent={'flex-start'}
          className={isPreRegistration ? 'pre-label' : ''}
        >
          <FormLabel
            htmlFor={id}
            required={isPreRegistration ? undefined : required}
          >
            {t(label)}
            {isPreRegistration && (
              <Typography className='required'>
                {t('common.required')}
              </Typography>
            )}
          </FormLabel>
        </Grid>
      )}
      <Grid item xs={8}>
        <TextField
          id={id}
          name={id}
          type='text'
          inputMode='numeric'
          value={displayValue}
          sx={{ width: width }}
          onChange={handleChange}
          placeholder='・・-・・'
          disabled={disabled}
          error={!!error}
          helperText={isShowText && errorText}
          InputProps={{
            endAdornment: icon ? (
              <InputAdornment position='end'>
                <IconButton tabIndex={-1} aria-label='icon-input' edge='end'>
                  {icon}
                </IconButton>
              </InputAdornment>
            ) : undefined,
          }}
        />
      </Grid>
    </Grid>
  );
};

export default CarNumberField;
